import { render, staticRenderFns } from "./invite.vue?vue&type=template&id=12e88ea2&scoped=true&"
import script from "./invite.vue?vue&type=script&lang=js&"
export * from "./invite.vue?vue&type=script&lang=js&"
import style0 from "./invite.css?vue&type=style&index=0&id=12e88ea2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e88ea2",
  null
  
)

export default component.exports